(function () {
  var drawer = document.getElementById('cd-cart-drawer');
  if (!drawer) return;

  var body = drawer.querySelector('[data-cart-drawer-body]');
  var currency = drawer.getAttribute('data-currency') || 'EUR';
  var continueUrl = drawer.getAttribute('data-continue-url') || '/';
  var cartUrl = drawer.getAttribute('data-cart-url') || '/cart';

  function formatMoney(cents) {
    try {
      return (cents / 100).toLocaleString('pt-PT', { style: 'currency', currency: currency });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    if (!cart.items.length) {
      body.innerHTML =
        '<div class="cd-cart-drawer__empty">' +
        '<h2 class="cd-cart-drawer__empty-title">O seu carrinho está vazio</h2>' +
        '<a class="cd-cart-drawer__btn" href="' + continueUrl + '">Continuar a comprar</a>' +
        '</div>';
      return;
    }

    var itemsHtml = cart.items.map(function (item) {
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cd-cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';
      var imgSrc = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_150x150$1$2') : '';
      return (
        '<div class="cd-cart-drawer__item" data-cart-drawer-item data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cd-cart-drawer__item-media">' +
        (imgSrc ? '<img class="cd-cart-drawer__item-img" src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '">' : '') +
        '</a>' +
        '<div>' +
        '<a href="' + item.url + '" class="cd-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
        variantHtml +
        '</div>' +
        '<div class="cd-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cd-cart-drawer__qty">' +
        '<button type="button" class="cd-cart-drawer__qty-btn" data-cart-qty-decrease>&minus;</button>' +
        '<span class="cd-cart-drawer__qty-value">' + item.quantity + '</span>' +
        '<button type="button" class="cd-cart-drawer__qty-btn" data-cart-qty-increase>+</button>' +
        '</div>' +
        '<button type="button" class="cd-cart-drawer__item-remove" data-cart-remove aria-label="Remover ' + escapeHtml(item.product_title) + '">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2m2 0-1 13a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2L7 7"></path></svg>' +
        '</button>' +
        '</div>'
      );
    }).join('');

    body.innerHTML =
      '<div class="cd-cart-drawer__items">' + itemsHtml + '</div>' +
      '<div class="cd-cart-drawer__footer">' +
      '<div class="cd-cart-drawer__subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<p class="cd-cart-drawer__note">Portes e descontos calculados no checkout.</p>' +
      '<a class="cd-cart-drawer__btn cd-cart-drawer__btn--full cd-cart-drawer__btn--outline" href="' + cartUrl + '">Ver carrinho</a>' +
      '<a class="cd-cart-drawer__btn cd-cart-drawer__btn--full cd-cart-drawer__btn--green" href="/checkout">Finalizar compra</a>' +
      '</div>';
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-drawer-toggle]');
    if (toggle) {
      e.preventDefault();
      openDrawer();
      fetchCart();
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }
    var itemEl = e.target.closest('[data-cart-drawer-item]');
    if (!itemEl) return;
    var key = itemEl.getAttribute('data-key');
    var qtyValueEl = itemEl.querySelector('.cd-cart-drawer__qty-value');
    var currentQty = parseInt(qtyValueEl.textContent, 10) || 1;

    if (e.target.closest('[data-cart-qty-increase]')) {
      changeItem(key, currentQty + 1);
    } else if (e.target.closest('[data-cart-qty-decrease]')) {
      changeItem(key, Math.max(0, currentQty - 1));
    } else if (e.target.closest('[data-cart-remove]')) {
      changeItem(key, 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () {
        openDrawer();
        fetchCart();
      });
  });
})();
